import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AiIntegrationView } from "../../../useSearchAiIntegrations/gql";

const IntegrationsAiTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {item.space &&
        <TableCellSpace href={`/spaces/${item.space.id}`}>
          {item.space.name}
        </TableCellSpace>
      }
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableSpaceCell;
